import React, { useState, useEffect } from 'react';
import { FaFilter } from 'react-icons/fa';
import { Productpolo } from "../../../Utility/Api";
import 'bootstrap/dist/css/bootstrap.min.css';
import { NaviGate } from '../../../Utility/function';

const ProductProfitLoss = () => {
  const [ledgerEntries, setLedgerEntries] = useState([]);  // Full dataset
  const [filteredEntries, setFilteredEntries] = useState([]); // Filtered data
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [accountTypeFilter, setAccountTypeFilter] = useState('All');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Productpolo();
      if (response.data && response.data.data) {
        const { product_profit_data, suppliers_credit_data, suppliers_data } = response.data.data;

        // Combine all data into ledger entries
        const entries = [
          ...product_profit_data.map((p) => ({
            type: 'Sales',
            name: p.product_name,
            amount: p.profit > 0 ? p.profit : -p.loss,
            date: new Date().toISOString().split('T')[0], // Placeholder date; replace with actual if available
          })),
          ...suppliers_credit_data.map((s) => ({
            type: 'Supplier Credits',
            name: s.supplier_name,
            amount: s.total_amount,
            date: new Date().toISOString().split('T')[0], // Placeholder date
          })),
          ...suppliers_data.map((s) => ({
            type: 'Supplier Purchases',
            name: s.supplier_name,
            amount: -s.total_amount, // Negative for purchases
            date: new Date().toISOString().split('T')[0], // Placeholder date
          })),
        ];
        setLedgerEntries(entries);
        setFilteredEntries(entries); // Initially, filtered = full data
      }
    } catch (error) {
      console.error("Error fetching ledger data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle filter button click
  const handleFilter = (e) => {
    e.preventDefault();

    const filtered = ledgerEntries.filter((entry) => {
      const entryDate = new Date(entry.date);
      const from = fromDate ? new Date(fromDate) : null;
      const to = toDate ? new Date(toDate) : null;

      const dateMatch =
        (!from || entryDate >= from) && (!to || entryDate <= to);
      const typeMatch =
        accountTypeFilter === 'All' || entry.type === accountTypeFilter;

      return dateMatch && typeMatch;
    });

    setFilteredEntries(filtered);
  };

  // Calculate totals for filtered entries
  const totalCredit = filteredEntries
    .filter(entry => entry.amount > 0)
    .reduce((acc, entry) => acc + entry.amount, 0)
    .toFixed(3);

  const totalDebit = filteredEntries
    .filter(entry => entry.amount < 0)
    .reduce((acc, entry) => acc + Math.abs(entry.amount), 0)
    .toFixed(3);

  // Closing Balance (To ensure tally)
  const closingBalance = (totalCredit - totalDebit).toFixed(3);

  return (
    <div className="page-content py-1">
          <NaviGate />
          <div className=" card  p-3  mx-2 " style={{height:"90vh"}} >
        <h5 className="text-start mb-3 fw-bold border-bottom pb-3">
          General Ledger 
        </h5>

      {/* Filter Form */}
      <form onSubmit={handleFilter} className="card p-3 shadow-sm mb-4">
        <div className="row g-3 align-items-center">
          <div className="col-md-3">
            <div className="form-floating">
              <input
                type="date"
                className="form-control"
                id="fromDate"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <label htmlFor="fromDate">From Date</label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating">
              <input
                type="date"
                className="form-control"
                id="toDate"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
              <label htmlFor="toDate">To Date</label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating">
              <select
                className="form-select"
                id="accountType"
                value={accountTypeFilter}
                onChange={(e) => setAccountTypeFilter(e.target.value)}
              >
                <option value="All">All Accounts</option>
                <option value="Sales">Sales</option>
                <option value="Supplier Credits">Supplier Credits</option>
                <option value="Supplier Purchases">Supplier Purchases</option>
              </select>
              <label htmlFor="accountType">Account Type</label>
            </div>
          </div>
          <div className="col-md-3">
            <button type="submit" className="btn btn-primary w-100 p-2">
              <FaFilter className="me-2" /> Apply Filter
            </button>
          </div>
        </div>
      </form>

      {/* Ledger Table */}
      <div className="card shadow-sm border-0">
        <div className="card-header bg-dark text-white">📊 Ledger Entries</div>
        <div className="card-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {loading ? (
            <div className="text-center">
              <div className="spinner-border text-primary"></div>
            </div>
          ) : filteredEntries.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-dark text-center">
                  <tr>
                    <th>Date</th>
                    <th>Account Type</th>
                    <th>Description</th>
                    <th>Debit (₹)</th>
                    <th>Credit (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEntries.map((entry, index) => (
                    <tr key={index}>
                      <td>{entry.date}</td>
                      <td>{entry.type}</td>
                      <td>{entry.name}</td>
                      <td className="text-danger fw-bold">
                        {entry.amount < 0 ? Math.abs(entry.amount).toFixed(3) : '-'}
                      </td>
                      <td className="text-success fw-bold">
                        {entry.amount > 0 ? entry.amount.toFixed(3) : '-'}
                      </td>
                    </tr>
                  ))}
                  {/* Totals Row */}
                  <tr className="table-secondary fw-bold">
                    <td colSpan="3" className="text-end">Total</td>
                    <td>₹{totalDebit}</td>
                    <td>₹{totalCredit}</td>
                  </tr>
                  <tr className="fw-bold">
  <td colSpan="3" className="text-end">Closing Balance</td>
  <td colSpan="2" className={closingBalance >= 0 ? "text-success" : "text-danger"}>
    {closingBalance >= 0 ? `₹${closingBalance} (Credit ✅)` : `₹${closingBalance} (Debit ❌)`}
  </td>
</tr>

                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-muted text-center">No ledger entries available</p>
          )}
        </div>
      </div>
    </div>
    </div>
  );
};

export default ProductProfitLoss;
